import { AppEnvironment, AppSettings } from '@customTypes/app';

export const KEYCLOAK_URL = 'https://auth.myome.com';
export const KEYCLOAK_CLIENT_ID = 'patient-portal';
export const SENTRY_DSN =
  'https://7fe2161745e24f04a059623ab4e2ebc6@o4506186993238016.ingest.sentry.io/4506832886628352';

const OPENREPLAY_PROD_PROJECT_KEY = 'lxa999lsaCVIlBktZdhM';
const OPENREPLAY_NON_PROD_PROJECT_KEY = 'IaPVLHXp3WFHPH81EHkk';
const OPENREPLAY_INGEST_POINT = 'https://openreplay.prd.myome.com/ingest';

export const ENVIRONMENT_SETTINGS: Record<string, AppSettings> = {
  tst: {
    baseurl: 'https://patients.tst.myome.info',
    apiUrl: 'https://api.tst.myome.info/0',
    environment: AppEnvironment.TEST,
    ga_id: 'G-3D9FQ6NM9K',
    stripe_api_key:
      'pk_test_51LuhuOJBauKDT6tuaPTfQBHEJxbI1yvxs6YiqoZvETf42hyFws6wrMajRRHU7B7zTZRcKttFkNqZqNk2Xjq5HvLF00sqQ06Wsp',
    googleMapsApiKey: 'AIzaSyD0B_jmB39u-gRWewG4L3Fu_abu2kOY_1c',
    turnstileSiteKey: '0x4AAAAAAFH6jwYuPipolbeZ',
    keycloakRealm: 'tst',
    sentry_enabled: true,
    sentryDSN: SENTRY_DSN,
    openreplayProjectKey: OPENREPLAY_NON_PROD_PROJECT_KEY,
    openreplayIngestPoint: OPENREPLAY_INGEST_POINT,
  },
  sbx: {
    baseurl: 'https://patients.sbx.myome.com',
    apiUrl: 'https://api.sbx.myome.com/0',
    environment: AppEnvironment.SANDBOX,
    ga_id: 'G-3D9FQ6NM9K',
    stripe_api_key:
      'pk_test_51LuhuOJBauKDT6tuaPTfQBHEJxbI1yvxs6YiqoZvETf42hyFws6wrMajRRHU7B7zTZRcKttFkNqZqNk2Xjq5HvLF00sqQ06Wsp',
    googleMapsApiKey: 'AIzaSyD0B_jmB39u-gRWewG4L3Fu_abu2kOY_1c',
    turnstileSiteKey: '0x4AAAAAAFH6kv6rzvc133ml',
    keycloakRealm: 'sbx',
    sentry_enabled: true,
    sentryDSN: SENTRY_DSN,
    openreplayProjectKey: OPENREPLAY_NON_PROD_PROJECT_KEY,
    openreplayIngestPoint: OPENREPLAY_INGEST_POINT,
  },
  stg: {
    baseurl: 'https://patients.stg.myome.info',
    apiUrl: 'https://api.stg.myome.info/0',
    environment: AppEnvironment.STAGING,
    ga_id: 'G-3D9FQ6NM9K',
    stripe_api_key:
      'pk_test_51LuhuOJBauKDT6tuaPTfQBHEJxbI1yvxs6YiqoZvETf42hyFws6wrMajRRHU7B7zTZRcKttFkNqZqNk2Xjq5HvLF00sqQ06Wsp',
    googleMapsApiKey: 'AIzaSyD0B_jmB39u-gRWewG4L3Fu_abu2kOY_1c',
    turnstileSiteKey: '0x4AAAAAAFH6S3m_DD2l6zs1',
    keycloakRealm: 'stg',
    sentry_enabled: true,
    sentryDSN: SENTRY_DSN,
    openreplayProjectKey: OPENREPLAY_NON_PROD_PROJECT_KEY,
    openreplayIngestPoint: OPENREPLAY_INGEST_POINT,
  },
  dev: {
    baseurl: 'https://patients.dev.myome.info',
    apiUrl: 'https://api.dev.myome.info/0',
    environment: AppEnvironment.DEV,
    ga_id: 'G-3D9FQ6NM9K',
    stripe_api_key:
      'pk_test_51LuhuOJBauKDT6tuaPTfQBHEJxbI1yvxs6YiqoZvETf42hyFws6wrMajRRHU7B7zTZRcKttFkNqZqNk2Xjq5HvLF00sqQ06Wsp',
    googleMapsApiKey: 'AIzaSyCDR9y7bIuzn2VXdYy_vaQf1VAZmChEmEs',
    turnstileSiteKey: '0x4AAAAAAFH5-1jluQ7TU8WH',
    keycloakRealm: 'dev',
    sentry_enabled: true,
    sentryDSN: SENTRY_DSN,
    openreplayProjectKey: OPENREPLAY_NON_PROD_PROJECT_KEY,
    openreplayIngestPoint: OPENREPLAY_INGEST_POINT,
  },
  prd: {
    baseurl: 'https://patients.myome.com',
    apiUrl: 'https://api.myome.com/0',
    environment: AppEnvironment.PROD,
    ga_id: 'G-57S8D12X5M',
    stripe_api_key:
      'pk_live_51LuhuOJBauKDT6tuDeQ7i97Vdteof0b5ADFENzjIAxEMQW7feFAYBxNXLb76PuPI3o8BRgIOYLSsHq9oiJbT02Pj00vjwtGFYN',
    googleMapsApiKey: 'AIzaSyD0B_jmB39u-gRWewG4L3Fu_abu2kOY_1c',
    turnstileSiteKey: '0x4AAAAAAFH6zMuctYXZR8aR',
    keycloakRealm: 'prd',
    sentry_enabled: true,
    sentryDSN: SENTRY_DSN,
    openreplayProjectKey: OPENREPLAY_PROD_PROJECT_KEY,
    openreplayIngestPoint: OPENREPLAY_INGEST_POINT,
  },
  local: {
    baseurl: 'http://localhost',
    apiUrl: process.env.REACT_APP_API_URL || 'https://api.dev.myome.info/0',
    environment: AppEnvironment.LOCAL,
    ga_id: 'G-3D9FQ6NM9K',
    stripe_api_key:
      'pk_test_51LuhuOJBauKDT6tuaPTfQBHEJxbI1yvxs6YiqoZvETf42hyFws6wrMajRRHU7B7zTZRcKttFkNqZqNk2Xjq5HvLF00sqQ06Wsp',
    googleMapsApiKey: 'AIzaSyCDR9y7bIuzn2VXdYy_vaQf1VAZmChEmEs',
    turnstileSiteKey: '0x4AAAAAAFH5-1jluQ7TU8WH',
    keycloakRealm: 'dev',
    sentry_enabled: false,
    sentryDSN: null,
    openreplayProjectKey: OPENREPLAY_NON_PROD_PROJECT_KEY,
    openreplayIngestPoint: OPENREPLAY_INGEST_POINT,
  },
  // Preview hosts. Copied from dev, including the dev sitekey (realm is dev). baseurl is not used for matching.
  vercel: {
    baseurl: 'https://patients.dev.myome.info',
    apiUrl: 'https://api.dev.myome.info/0',
    environment: AppEnvironment.DEV,
    ga_id: 'G-3D9FQ6NM9K',
    stripe_api_key:
      'pk_test_51LuhuOJBauKDT6tuaPTfQBHEJxbI1yvxs6YiqoZvETf42hyFws6wrMajRRHU7B7zTZRcKttFkNqZqNk2Xjq5HvLF00sqQ06Wsp',
    googleMapsApiKey: 'AIzaSyCDR9y7bIuzn2VXdYy_vaQf1VAZmChEmEs',
    turnstileSiteKey: '0x4AAAAAAFH5-1jluQ7TU8WH',
    keycloakRealm: 'dev',
    sentry_enabled: true,
    sentryDSN: SENTRY_DSN,
    openreplayProjectKey: OPENREPLAY_NON_PROD_PROJECT_KEY,
    openreplayIngestPoint: OPENREPLAY_INGEST_POINT,
  },
};

// *.vercel.app is selected by hostname so it does not fall through to dev. Its copied baseurl is skipped below.
const prefixMatch = Object.values(ENVIRONMENT_SETTINGS).find(
  (config: AppSettings) => config !== ENVIRONMENT_SETTINGS.vercel && window.location.href.startsWith(config.baseurl),
);
const foundSettings = window.location.hostname.endsWith('.vercel.app') ? ENVIRONMENT_SETTINGS.vercel : prefixMatch;

// Default to "dev" if no match
const appSettings: AppSettings = foundSettings || ENVIRONMENT_SETTINGS.dev;

if (!foundSettings) {
  console.error('No environment config found for the current URL. Using default.');
}

export const APP_SETTINGS: AppSettings = appSettings;

// Export envInfo for backward compatibility (provides snake_case property access)
// This maintains the existing interface used throughout the codebase
export const envInfo = {
  baseurl: appSettings.baseurl,
  apiUrl: appSettings.apiUrl,
  ga_id: appSettings.ga_id,
  stripe_api_key: appSettings.stripe_api_key,
  googleMapsApiKey: appSettings.googleMapsApiKey,
  keycloak_realm: appSettings.keycloakRealm,
  sentry_enabled: appSettings.sentry_enabled,
  openreplay_project_key: appSettings.openreplayProjectKey,
  openreplay_ingest_point: appSettings.openreplayIngestPoint,
};

export const ORDER_STATUS_STEPS = [
  {
    step: 'SUBMITTED',
    icon: ['fa-duotone', 'fa-box-check'],
    label: 'Order Placed',
  },
  {
    step: 'APPROVED',
    icon: ['fa-duotone', 'fa-memo-circle-check'],
    label: 'Order Approved',
  },
  {
    step: 'AWAITING_SAMPLE',
    icon: ['fa-duotone', 'fa-hourglass-clock'],
    label: 'Awaiting Sample',
  },
  {
    step: 'ANALYZING',
    icon: ['fa-duotone', 'fa-magnifying-glass-chart'],
    label: 'Analysis',
  },
  {
    step: 'CLINICIAN_REVIEW',
    icon: ['fa-duotone', 'fa-user-doctor-message'],
    label: 'Clinician Review',
  },
  {
    step: 'COMPLETED',
    icon: ['fa-duotone', 'fa-file-chart-column'],
    label: 'Results Ready',
  },
];

export const QUESTIONNAIRE_QUESTIONS = {
  QNR_FHX_1: {
    options: [
      { displayValue: 'Yes', value: 'YES', showRecommended: false },
      { displayValue: 'No', value: 'NO', showRecommended: false },
    ],
  },
  QNR_FHX_2: {
    options: [
      { displayValue: 'Yes', value: 'YES', showRecommended: false },
      { displayValue: 'No', value: 'NO', showRecommended: false },
    ],
  },
  QNR_FHX_3: {
    options: [
      { displayValue: 'Yes', value: 'YES', showRecommended: false },
      { displayValue: 'No', value: 'NO', showRecommended: false },
    ],
  },
  QNR_FHX_4: {
    options: [
      { displayValue: 'Yes', value: 'YES', showRecommended: false },
      { displayValue: 'No', value: 'NO', showRecommended: false },
    ],
  },
  QNR_FHX_5: {
    options: [
      { displayValue: 'Yes', value: 'YES', showRecommended: false },
      { displayValue: 'No', value: 'NO', showRecommended: false },
    ],
  },
  QNR_FHX_8: {
    options: [
      { displayValue: 'Yes', value: 'YES', showRecommended: false },
      { displayValue: 'No', value: 'NO', showRecommended: false },
    ],
  },
  QNR_FHX_9: {
    options: [
      { displayValue: 'Yes', value: 'YES', showRecommended: false },
      { displayValue: 'No', value: 'NO', showRecommended: false },
    ],
  },
};

export const SMOKING_STATUS = [
  { value: 'CURRENT', label: 'Current Smoker' },
  { value: 'FORMER', label: 'Former Smoker' },
  { value: 'NEVER', label: 'Non-Smoker' },
];

export const CONSENT_CHOICES = [
  {
    label: "I accept MyOme's Informed Consent Agreement",
    value: 'myome:consent:GENERAL-0.0.1',
  },
  {
    label: 'I accept the <a>DNAvisit Physician-of-Record Informed Consent</a>',
    value: 'myome:consent:DNAVISIT-0.0.1',
  },
];

export const US_STATES: FormSelectOptions = [
  { value: 'AL', label: 'AL' },
  { value: 'AK', label: 'AK' },
  { value: 'AZ', label: 'AZ' },
  { value: 'AR', label: 'AR' },
  { value: 'CA', label: 'CA' },
  { value: 'CO', label: 'CO' },
  { value: 'CT', label: 'CT' },
  { value: 'DE', label: 'DE' },
  { value: 'DC', label: 'DC' },
  { value: 'FL', label: 'FL' },
  { value: 'GA', label: 'GA' },
  { value: 'HI', label: 'HI' },
  { value: 'ID', label: 'ID' },
  { value: 'IL', label: 'IL' },
  { value: 'IN', label: 'IN' },
  { value: 'IA', label: 'IA' },
  { value: 'KS', label: 'KS' },
  { value: 'KY', label: 'KY' },
  { value: 'LA', label: 'LA' },
  { value: 'ME', label: 'ME' },
  { value: 'MD', label: 'MD' },
  { value: 'MA', label: 'MA' },
  { value: 'MI', label: 'MI' },
  { value: 'MN', label: 'MN' },
  { value: 'MS', label: 'MS' },
  { value: 'MO', label: 'MO' },
  { value: 'MT', label: 'MT' },
  { value: 'NE', label: 'NE' },
  { value: 'NV', label: 'NV' },
  { value: 'NH', label: 'NH' },
  { value: 'NJ', label: 'NJ' },
  { value: 'NM', label: 'NM' },
  { value: 'NY', label: 'NY' },
  { value: 'NC', label: 'NC' },
  { value: 'ND', label: 'ND' },
  { value: 'OH', label: 'OH' },
  { value: 'OK', label: 'OK' },
  { value: 'OR', label: 'OR' },
  { value: 'PA', label: 'PA' },
  { value: 'RI', label: 'RI' },
  { value: 'SC', label: 'SC' },
  { value: 'SD', label: 'SD' },
  { value: 'TN', label: 'TN' },
  { value: 'TX', label: 'TX' },
  { value: 'UT', label: 'UT' },
  { value: 'VT', label: 'VT' },
  { value: 'VA', label: 'VA' },
  { value: 'WA', label: 'WA' },
  { value: 'WV', label: 'WV' },
  { value: 'WI', label: 'WI' },
  { value: 'WY', label: 'WY' },
];

// prettier-ignore
export const GC_LANGUAGE = [
  'You have indicated a family history of cancer and/or cardiac disease, or that you are uncertain of your family history.',
  "MyOme's screening tests are not necessarily appropriate for individuals who have a personal or family history of these diseases.",
  'If your reason for testing is to understand your risks for these diseases in the context of your personal or family history, a diagnostic test may provide a more comprehensive assessment of your risk for these diseases. You should speak with your physician.',
  'If you proceed with testing at MyOme, we recommend that you receive genetic counseling. Genetic counseling will be made available to you at no additional cost to help understand your test results in the context of your personal or family history.',
  'If you do not wish to proceed with testing, please stop now without submitting your order. Your credit card will not be charged and no personal information will be retained.',
];

export const PRODUCT_NOTIFICATIONS_CONSENT = 'myome:consent:PRODUCT_NOTIFICATIONS-0.0.1';

export const CONSENT_URI = {
  HIE_ACCESS_TREATMENT: 'myome:consent:HIE_ACCESS__TREATMENT',
  CONTACT_RESEARCH_OPPORTUNITIES: 'myome:consent:CONTACT__RESEARCH_OPPORTUNITIES',
  CONTACT_TRANSACTIONAL_SMS: 'myome:consent:CONTACT__TRANSACTIONAL_SMS',
  CONTACT_MARKETING: 'myome:consent:CONTACT__MARKETING',
};

// for the reports page:

export const CURES_ACT_MODAL_BUTTONS_INFO = [
  {
    buttonLabel: 'Wait for clinician to release results with a summary',
    styleClass: 'primaryButtonStyling',
    btnType: 'WAIT_FOR_RESULTS',
    buttonStyling: {
      marginRight: '12px',
      width: window.innerWidth < 560 ? '100%' : '240px',
      backgroundColor: '#177B21',
      border: '1px solid #177B21',
      padding: '8px',
      fontSize: '12px',
      fontWeight: '700',
      whiteSpace: 'normal',
      lineHeight: '1.3',
    },
  },
  {
    buttonLabel: 'Receive results immediately without a summary',
    styleClass: 'dangerButtonStyling',
    btnType: 'REQUEST_WITHOUT_COUNSELING',
    buttonStyling: {
      width: window.innerWidth < 560 ? '100%' : '240px',
      padding: '8px',
      backgroundColor: '#BB0909',
      border: '1px solid #BB0909',
      fontSize: '12px',
      fontWeight: '700',
      color: '#FFFFFF',
      whiteSpace: 'normal',
      lineHeight: '1.3',
    },
  },
];

export const RECEIPT_MODAL_BUTTON_INFO = [
  {
    buttonLabel: 'Print Receipt',
    styleClass: 'secondaryButtonStyling',
    btnType: 'PRINT_RECEIPT',
    buttonStyling: {
      padding: window.innerWidth < 560 ? '5px' : '',
    },
    dataTestId: 'printReceiptBtn',
  },
];

export const CURES_ACT_LANGUAGE = {
  // prettier-ignore
  PART_ONE:
    'You are strongly encouraged to wait for review of your results by a licensed medical professional to be complete. They will release the results to you with a summary letter once it’s ready. However, the 21st Century Cures Act requires that results be made available to you without delay. If you choose to receive results now, they will be available to you immediately. You will receive a summary letter at a later date and will have the option to schedule post-test genetic counseling.',
  // prettier-ignore
  PART_TWO: 'Please select how you would like to proceed:',
};

// for the checkout page

export const TEST_SELECTION_LIST = [
  'Clinical grade whole-genome DNA sequencing that can be reanalyzed for future tests with MyOme',
  'Proactive Health Report, Single Gene Risk 84 Genes',
  'Medication Response Report',
  'CAD PRS',
  'Clinician order review with DNAvisit',
  'Post-test genetic counseling to help you understand your results',
  'Access to your results through MyOme’s secure patient portal',
];

export const MIN_AGE = 17;
export const MYOME_URL = 'https://www.myome.com';
export const RESOURCES_URL = `${MYOME_URL}/resources/patient-resources`;
export const CONTACT_US_URL = `${MYOME_URL}/contact-us`;
export const PRIVACY_NOTICE_URL = `${MYOME_URL}/privacy-notice`;
export const TERMS_OF_SERVICE_URL = `${MYOME_URL}/terms-of-service`;
export const HIPAA_URL = `${MYOME_URL}/hipaa-notice-of-privacy-practices/`;
export const MYOME_SUPPORT_EMAIL = 'support@myome.com';
export const MYOME_SUPPORT_PHONE = '888-336-0803';
export const MYOME_SUPPORT_PHONE_TEL = 'tel:8883360803';
